"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicMetaData = void 0;

var _q = _interopRequireDefault(require("q"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var fetchPublicMetaData = function fetchPublicMetaData(countryOverride) {
  // This logic and code should be kept consistent with publicEarlyRequester.js
  var navigator = window.navigator;
  var preferredLanguage = navigator.languages || navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
  var publicMetaUrl = '/api-passthrough/eligibility-engine/v2/public';

  if (preferredLanguage && preferredLanguage.length) {
    if (Array.isArray(preferredLanguage)) {
      // This is simpler than the existing dot com logic
      // but I think this is sufficient since the fallbacks
      // aren't very important
      // See: https://codepen.io/anythingcodes/pen/XwdzYW?editors=0010
      preferredLanguage = preferredLanguage[0];
    }

    publicMetaUrl = publicMetaUrl + "/" + preferredLanguage.toLowerCase();
  }

  var isInIndia = window.location.host.indexOf('hubspot.in') > -1;
  var preferredCountryFromDomain = isInIndia ? 'in' : window.COUNTRY_CODE_FROM_LOCALE;
  var preferredCountry = countryOverride || preferredCountryFromDomain;

  if (preferredCountry) {
    publicMetaUrl = publicMetaUrl + "?preferredCountry=" + preferredCountry;
  }

  return _noAuthApiClient.default.get(publicMetaUrl);
}; // Quick fetched, check publicEarlyRequester.js


var getPublicMetaData = function getPublicMetaData() {
  var countryOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName('public-meta');

  if (earlyRequest) {
    return new _q.default.Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        resolve(result);
        window.quickFetch.removeEarlyRequest('purchase-motions');
      });
      earlyRequest.onError(function () {
        fetchPublicMetaData(countryOverride).then(resolve).catch(function (error) {
          reject(error);
        });
        window.quickFetch.removeEarlyRequest('purchase-motions');
      });
    });
  } else {
    return fetchPublicMetaData(countryOverride);
  }
};

exports.getPublicMetaData = getPublicMetaData;


//////////////////
// WEBPACK FOOTER
// ./js/api/public-only/PublicMetaDataApi.js
// module id = 890
// module chunks = 5 6